export default __webpack_public_path__ + "static/media/film.54a73a11.png";